import React from 'react';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import { Skeleton } from '@/components/ui/skeleton';
import { useProtectedStorageUrl } from './useProtectedStorageUrl';

interface SignaturePreviewDialogProps {
  signatureUrl?: string;
  open: boolean;
  onOpenChange: (open: boolean) => void;
  title: string;
}

export const SignaturePreviewDialog: React.FC<SignaturePreviewDialogProps> = ({
  signatureUrl,
  open,
  onOpenChange,
  title,
}) => {
  const { objectUrl, isLoading, hasError } = useProtectedStorageUrl(
    open ? signatureUrl : undefined
  );

  if (!signatureUrl) return null;

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-4xl max-h-[90dvh] overflow-hidden p-0">
        <DialogHeader className="border-b px-6 py-4">
          <DialogTitle>{title}</DialogTitle>
          <DialogDescription className="sr-only">
            Vista ampliada de la firma de {title}
          </DialogDescription>
        </DialogHeader>

        <div className="flex h-[70dvh] items-center justify-center bg-gray-100 p-6">
          {isLoading && <Skeleton className="h-full w-full rounded-lg" />}

          {!isLoading && objectUrl && (
            <img
              src={objectUrl}
              alt={`Firma de ${title}`}
              className="max-h-full max-w-full rounded-lg bg-white object-contain shadow-sm"
            />
          )}

          {!isLoading && hasError && (
            <div className="rounded-lg border border-red-200 bg-red-50 px-4 py-3 text-sm text-red-700">
              No se pudo cargar la firma.
            </div>
          )}
        </div>
      </DialogContent>
    </Dialog>
  );
};
